import { Col, Row } from "antd";
import { GrMenu } from "react-icons/gr";
import { BsChevronLeft } from "react-icons/bs";
import Button from "../Button";
import { isMobile } from "../../utils";
import { LayoutHeader, Title, WarningText, TitleContainer } from "./styles";
import { useAuth } from "../../contexts/AuthContext";
import { useHistory } from "../../contexts/HistoryContext";
import { ModalSupport } from "../ModalSupport";
import { useState } from "react";

interface IHeaderProps {}

const Header: React.FC<IHeaderProps> = () => {
  const { setShowDrawer } = useAuth();
  const { handleBackHistory } = useHistory();
  const [modal, setModal] = useState(false);

  return (
    <>
      <LayoutHeader>
        {isMobile() && (
          <Row
            align="middle"
            justify="space-between"
            style={{ width: "100%", flexWrap: "nowrap" }}
          >
            <Col>
              <Button
                type="link"
                className="back-button"
                icon={<BsChevronLeft />}
                onClick={handleBackHistory}
              />
            </Col>
            <Col onClick={() => setModal(true)}>
              <TitleContainer>
                <WarningText>Calculadora disponível até 31/12/2025</WarningText>
                <Title>Dúvidas ?</Title>
              </TitleContainer>
            </Col>
            <Col>
              <Button
                type="text"
                size="large"
                icon={<GrMenu />}
                className="menu-button"
                onClick={() => setShowDrawer(true)}
              />
            </Col>
          </Row>

        )}
        <ModalSupport
          visible={modal}
          closeFn={() => setModal(false)}
   
        />
      </LayoutHeader>
    </>
  );
};

export default Header;